<template>
  <v-container fluid>
    <h1 class="display-1 font-weight-bold mb-3">
      FAQ
    </h1>

    <v-btn @click="openAll">Open all</v-btn>
    <v-btn @click="closeAll">Close all</v-btn>

    <v-expansion-panels
      class="mt-3"
      focusable
      multiple
      v-model="faqselection"
    >
      <v-expansion-panel
        v-for="(faq, index) in faqs"
        :key="index"
      >
        <v-expansion-panel-header>
          {{faq.q}}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-5">
          <div v-html='faq.a'></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

  </v-container>
</template>

<script>
export default {
    name: "HowToStakeWise",
    data() {
      return {
        faqselection: [],
        faqs: [
          {
            q: "Is WISE a legit and honest project?",
            a: "Yes, all aspects of WISE look very legit and honest. These are just a few examples:<ul><li>Team is known, and verifyable, see <a href='https://wisetoken.net'>https://wisetoken.net</a></li><li>The contract is published, readable and audited, check it on <a href='https://etherscan.io/address/0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6'>etherscan.io</a> and <a href='https://wisetoken.net/Wise_Audit_Report.pdf'>Audit Report</a></li><li>The contract has no admin keys. It can't be changed anymore</li><li>Liquidity is \"ownerless\", see below what that means.</li><li>Funds/Return/Interest comes from inflation, provable in the contract</li><li>One-level Referral System like also Amazon and TESLA use it</li><li>Price discovery happens on regular (decentralized) markets with big liquidity</li></ul>"
          },
          {
            q: "What does \"Ownerless Liquidity\" mean?",
            a: "Nobody has the keys to remove the initial Liquidity of 55900 ETH and 260760440 WISE from Uniswap.<br />During the generation of the WISE/ETH pair on Uniswap, the keys to access this liquidity have been burned <a href='https://etherscan.io/tx/0xa009f81a0e7bed3fb331b28343ffc3f66f400024f09b8748e5a9476c73f19e3c'>provable</a> by sending it to the <a href='https://etherscan.io/address/0x0000000000000000000000000000000000000000'>burn address</a>"
          },
          {
            q: "How is the Price Floor of WISE calculated?",
            a: "The shown Price Floor is the price that would result on Uniswap if everybody would sell all of his liquid (non-staked) WISE on Uniswap"
          },
          {
            q: "What does \"Backed by ETH\" mean?",
            a: "The huge WISE/ETH liquidity pool on Uniswap allows every WISE token holder to cash out his WISE in ETH and appreciate the price increase of ETH vs USD by doing so."
          },
          {
            q: "Where is the interest/APY coming from?",
            a: "The interest/APY you get for your stakes is coming from yearly 4% inflation (3% to stakers, 1% to Referrers), and from penalties paid by stakers who unstake their WISE early."
          },
          {
            q: "Is WISE a stable coin?",
            a: "No, it is traded freely versus ETH and probably also versus other tokens. Because of the big liquidity on Uniswap, the volatility is much lower than with other tokens though. WISE is backed by ETH, it is not pegged to anything."
          },
        ]
      }
    },
    methods: {
      openAll() {
        this.faqselection = this.faqs.map((k, i) => i)
        console.log(this.faqselection);
      },
      closeAll() {
        this.faqselection = [];
        console.log(this.faqselection);
      }
    },
    components: {},
  };
</script>

<style>
</style>
